<template>
  <div>
    <div class="content-header">
      <ol class="breadcrumb">
        <li class="active">分佣列表</li>
      </ol>
    </div>
    <div class="content-query content-border">
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="submitQuery(1)" size="small">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <hr/>
    <div class="title">
      <span>分佣列表</span>
    </div>
    <el-table highlight-current-row :data="data">
      <el-table-column align="center" label="分类">
        <template slot-scope="scope">
          <span>{{ typeMap[scope.row.type] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" label="一级分润比例">
        <template slot-scope="scope">
          <el-input-number :disabled="scope.row.inputDisable" v-model="scope.row.firstParentRate"
                           :precision="2" :step="0.1" :min="0" :max="1"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="二级分润比例">
        <template slot-scope="scope">
          <el-input-number :disabled="scope.row.inputDisable" v-model="scope.row.secondParentRate"
                           :precision="2" :step="0.1" :min="0" :max="1"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="团长分润比例">
        <template slot-scope="scope">
          <el-input-number :disabled="scope.row.inputDisable" v-model="scope.row.leaderProfitRate"
                           :precision="2" :step="0.1" :min="0" :max="1"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="经理分润比例">
        <template slot-scope="scope">
          <el-input-number :disabled="scope.row.inputDisable" v-model="scope.row.managerProfitRate"
                           :precision="2" :step="0.1" :min="0"
                           :max="1"/>
        </template>
      </el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.inputDisable" content="编辑" placement="top"
                      effect="light">
            <el-button type="primary"
                       @click="edit(scope.row,false)"
                       size="mini"
                       icon="el-icon-edit" round/>
          </el-tooltip>
          <el-tooltip v-else content="保存" placement="top"
                      effect="light">
            <el-button type="primary"
                       @click="saveProfitRate(scope.row)"
                       size="mini"
                       icon="el-icon-document-checked" round/>
          </el-tooltip>
          <el-tooltip v-if="!scope.row.inputDisable" content="取消" placement="top"
                      effect="light">
            <el-button type="danger"
                       @click="edit(scope.row,true)"
                       size="mini"
                       icon="el-icon-s-release" round/>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <vue-pager v-bind:datafile="fillData" url="orderProfitRate/pageOrderProfitRate" v-bind:query="query" ref="pager"
               v-bind:init="true"></vue-pager>
  </div>
</template>
<script>
export default {
  data() {
    return {
      data: [],
      typeMap: {},
      types: [],
      query: {},
      dynamicPath: config.dynamicResourcePath,
    }
  },
  created() {
    var _this = this;
    _this.types = _this.$common.enum_config('EOrderProfitType');
    _this.types && _this.types.forEach((item) => {
      _this.typeMap[item.name] = item.label;
    });
  },
  methods: {
    fillData(response) {
      let items = response.items;
      items.forEach((item) => {
        Object.assign(item, {inputDisable: true});
      })
      this.data = items || [];
    },
    submitQuery(_num) {
      const _this = this;
      _this.data = [];
      _this.$refs.pager.gotoPage(_num);
    },
    edit(row, flag) {
      if (flag) {
        this.submitQuery(this.query.current);
      }
      Object.assign(row, {inputDisable: flag});
    },
    saveProfitRate(row) {
      const _this = this;
      delete row.inputDisable;
      let sum = parseFloat(row.firstParentRate) +
          parseFloat(row.secondParentRate) +
          parseFloat(row.managerProfitRate) +
          parseFloat(row.leaderProfitRate);
      if (sum > 1) {
        _this.$message({
          message: '总利润不能超过100%',
          type: 'error',
          duration: 1000,
          onClose: function () {
          }
        });
        return;
      }
      console.log(row)
      _this.$common.my_ajax({
        url: 'orderProfitRate/saveOrderProfitRate',
        data: row,
        success: function () {
          _this.$message({
            message: '操作成功',
            type: 'success',
            duration: 1000,
            onClose: function () {
              _this.submitQuery(_this.query.current);
            }
          });
        }
      });
    }
  },
}
</script>
<style scoped>
</style>